import _regenerator from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
//
//
//
//
//
//
//
//
//

export default {
  name: 'comSelect',
  props: ["value", "disabled", "placeholder", "multiple", "clearable", "filterable"],
  model: {
    prop: 'value',
    event: 'input'
  },
  data: function data() {
    return {
      treeData: [],
      innerValue: this.value
    };
  },
  methods: {
    getData: function () {
      var _getData = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return this.$store.dispatch('generator/getCompanyTree');
            case 1:
              this.treeData = _context.v;
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getData() {
        return _getData.apply(this, arguments);
      }
      return getData;
    }()
  },
  created: function created() {
    this.getData();
  },
  watch: {
    innerValue: function innerValue(val) {
      val && this.$emit('change', val);
    },
    value: function value(val) {
      this.innerValue = val;
    }
  }
};